module.exports = __webpack_public_path__ + "static/media/ZI.43ffc5cd.pdf";